import styled from 'styled-components';
import { colors } from 'bench-style-constants';

const styleTypesDefault = {
  small: {
    fontSize: '12px',
    fontWeight: '300',
    lineHeight: '16px',
  },
  medium: {
    fontSize: '14px',
    fontWeight: '300',
    lineHeight: '16px',
  },
  large: {
    fontSize: '16px',
    fontWeight: '300',
    lineHeight: '24px',
  },
  title: {
    fontSize: '24px',
    fontWeight: '700',
    lineHeight: '32px',
  },
};

const styleTypes = {
  ...styleTypesDefault,
  smallBold: {
    ...styleTypesDefault.small,
    fontWeight: '700',
  },
  mediumBold: {
    ...styleTypesDefault.medium,
    fontWeight: '700',
  },
  largeBold: {
    ...styleTypesDefault.large,
    fontWeight: '700',
  },
};

/**
 * Represents an inline, styled text element.
 *
 * Use this when you want to style the text of an inline element where there will be different text
 * styles in the same sentence or paragraph.
 *
 * If you need to align the text, to preserve whitespace, or to have a block level text element for
 * any other reason, use TextBlock instead.
 */
const Text = styled.div`
  color: ${({ color }) => color};
  display: inline;
  font-size: ${({ styleType }) => styleTypes[styleType].fontSize};
  font-weight: ${({ styleType }) => styleTypes[styleType].fontWeight};
  line-height: ${({ styleType }) => styleTypes[styleType].lineHeight};
  text-transform: ${({ uppercase }) => (uppercase ? 'uppercase' : 'none')};
`;

Text.defaultProps = {
  color: colors.charcoal,
  uppercase: false,
  styleType: 'medium',
};

export default Text;
